import React, { useEffect, useState, useContext } from "react";
import ReactPlayer from "react-player";
import { hasInternetConnection } from "../../services/systemService";
import { ModalDialog } from "./ModalDialog";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { XCircle } from "./IconsV2";
import { AccessibleFocusOutline } from "./AccessibleFocusOutline";

export const VideoPopup = ({
	show,
	onClose,
	title,
	videoUrl,
	onWatched,
	currentTheme,
}) => {
	const textColor = "white";

	const [hasError, setHasError] = useState(false);
	const [errorMessage, setErrorMessage] = useState(
		"The video could not be loaded. Please try again later."
	);

	const handleError = (error) => {
		if (hasInternetConnection()) {
		} else {
			setHasError(true);
			setErrorMessage(
				"There is no internet connection. The video cannot be played."
			);
		}
	};

	const handleOnProgress = (progress) => {
		if (progress.played > 0.8) {
			onWatched();
		}
	};

	const { theme } = useContext(DiseaseGroupContext);

	const [presetTheme, setPresetTheme] = useState(currentTheme);
	useEffect(() => {
		if (presetTheme) {
		} else {
			setPresetTheme(theme.primary());
		}
	}, []);

	return (
		<ModalDialog show={show} onClose={onClose}>
			<div className={"z-20 flex items-center justify-center text-black"}>
				<div
					className={`bg-white w-full max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl text-center p-3 sm:p-5 shadow-md border border-gray-200 rounded-md`}
				>
					<div
						className={
							"flex justify-between items-center gap-4 sm:gap-5 pb-3 sm:pb-5"
						}
					>
						<h5
							className={
								"text-sm sm:text-lg font-bold block text-left sm:leading-5"
							}
						>
							{hasError ? "ERROR" : title ? title : null}
						</h5>
						<AccessibleFocusOutline>
							<button onClick={onClose} className={"flex items-center"}>
								<span className={"text-xs sm:text-sm mr-1.5"}>Close</span>
								<XCircle
									className={`w-6 sm:w-12 text-${theme?.group}-primary`}
								/>
							</button>
						</AccessibleFocusOutline>
					</div>
					<div className={"h-40 sm:h-64 md:h-80 lg:h-96"}>
						<ReactPlayer
							width={"100%"}
							height={"100%"}
							playing={true}
							controls={true}
							url={videoUrl}
							onProgress={handleOnProgress}
							onError={handleError}
						/>
						{hasError ? <p className={"mt-3"}>{errorMessage}</p> : null}
					</div>
				</div>
			</div>
		</ModalDialog>
	);
};
